import sanityClient from '../Client'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { PortableText } from '@portabletext/react'
import { Richtext } from '../Components/Richtext'
import { Helmet } from 'react-helmet';
// import Toast from '../Components/Toast';
// import { useRef } from 'react';
// import { toast } from 'react-toastify';

function SinglePost() {
    // const toast1 = useRef(null)
    // const toast2 = useRef(null)
    // const close = (id) => {
    //     toast.dismiss(id.current)
    // }


    const [post, setPost] = useState(null)
    const { slug } = useParams()
    // console.log(slug)
    useEffect(() => {
        sanityClient.fetch(`*[slug.current == "${slug}"]{
            title,
            description,
            _id,
            slug,
            mainImage {
                asset->{
                  _id,
                  url
                },
                alt
              },
            body,
            publishedAt,
            "categories": categories[]->title,
            author->{
                name,
                image {
                  asset->{
                    url
                  }
                }
              }
        }`).then((data) => setPost(data[0]))
            .catch(error => console.error(error))

    }, [slug])

    if (!post) return <div className='min-h-[calc(100vh-80px)] bg-[#161623] text-gray-200'>Loading...</div>


    return (
        <>
            <main className='min-h-[calc(100vh-80px)] bg-[#161623] '>
                <Helmet>
                    <title>{post.title}</title>
                    <meta name="description" content={post.description} />
                    <meta name="keywords" content="react, blog, SEO, tips, blogging, reactjs" />
                    <meta name="author" content={post.author.name} />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <link rel="canonical" href={`https://getblogcode.netlify.app/blogs/${slug}`} />
                </Helmet>
                {/* <Toast content={<>
                    <h1 className='text-2xl font-bold'>Sign up Now!</h1>
                    <p>Get 100+ leads in seconds</p>
                    <input type="email" placeholder='email here' className='border' />
                    <button className='bg-blue-500 text-white px-2' onClick={() => close(toast1)}>Submit</button>
                </>}
                    position='top-center'
                    toastRef={toast1}
                /> */}


                {/* <Toast content={<>
                    <h1 className='text-2xl font-bold'>Join our newsletter</h1>
                    <p>Get insider tips</p>
                    <input type="email" placeholder='email here' className='border' />
                    <button className='bg-blue-500 text-white px-2' onClick={() => close(toast2)}>Submit</button>
                </>}
                    position='bottom-left'
                    toastRef={toast2}
                /> */}
                <article className='container mx-auto pt-8 py-16 flex flex-col gap-4 px-2 md:max-w-3xl lg:max-w-5xl' itemscope itemtype="https://schema.org/BlogPosting">
                    <Link to="/blogs" className='text-gray-400'>← Back to Blogs</Link>
                    <h1 className='text-5xl font-bold text-gray-100' itemProp='headline'>{post.title}</h1>
                    <p itemProp='abstract' className='text-gray-300'>{post.description}</p>
                    <div className='flex items-center gap-4 rounded-b-xl'>
                        <img src={post.author?.image?.asset.url} alt="author" className='h-12' itemprop="image" />
                        <span itemprop="author" itemscope itemtype="https://schema.org/Person" className='text-gray-200'>{post.author.name}</span>
                        <span className='text-gray-300'>Published on {new Date(post.publishedAt).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                    </div>
                    <div className='flex gap-2'>
                        {post?.categories && post.categories.map((tag, index) => (
                            <Link to={`/blogs/tags/${tag}`} className='bg-[#D72638] text-white py-1 px-3 rounded-xl w-min hover:bg-transparent hover:text-[#D72638] hover:border-[#D72638] border' key={index}>{tag}</Link>
                        ))}
                    </div>
                    <img src={post?.mainImage?.asset.url} alt={post?.mainImage?.alt ? post?.mainImage?.alt : 'Image alt'} className=' rounded-t-xl object-cover  w-full' onError={(e) => {
                        e.target.src = '/assets/gear.svg';
                    }} />

                    <PortableText value={post.body} components={Richtext} />
                </article>

            </main>
        </>
    )
}

export default SinglePost